export default {
  name: 'orcer-license-form',
  props: {},
  data () {
    return {
      buyOrderForm: {}
    }
  },
  methods: {
    handleSubmitOrder () {
      this.$emit('handleSubmitOrder', this.buyOrderForm)
      this.buyOrderForm = {}
    }
  }
}
